import React from 'react';
import { Icon } from './Icon.js';
export const IconTableRows2Cols3Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M12 8.25C12 9.76878 10.7688 11 9.25 11H9V6.75H12V8.25Z", fill: "currentColor" }),
        React.createElement("path", { d: "M7.5 11H4.5V6.75H7.5V11Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M3 11H2.75C1.23122 11 0 9.76878 0 8.25V6.75H3V11Z", fill: "currentColor" }),
        React.createElement("path", { d: "M7.5 5.25H4.5V1H7.5V5.25Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M3 5.25H0V3.75C0 2.23122 1.23122 1 2.75 1H3V5.25Z", fill: "currentColor" }),
        React.createElement("path", { d: "M9.25 1C10.7688 1 12 2.23122 12 3.75V5.25H9V1H9.25Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconTableRows2Cols3Fill12.js.map